import { Alert, AlertDescription, AlertTitle } from './ui/alert'
import { AlertCircleIcon } from 'lucide-react'

export const AlertRatio = () => {
  return (
    <Alert
      variant="default"
      className="bg-accent-3 border-accent-3 text-monochrome-1"
      title="The image uploaded has a different aspect ration than required. Please try again."
    >
      <AlertCircleIcon className="size-4 text-monochrome-1" />
      <AlertTitle className="text-body-medium text-monochrome-1">
        Attention!
      </AlertTitle>
      <AlertDescription className="text-body-medium text-monochrome-1">
        {`The image uploaded has a different aspect ration than required. Please try again.`}
      </AlertDescription>
    </Alert>
  )
}
